<section class="mt-2">
    <div class="action-btn px-4">
        <button class="mr-5" nz-button nzType="default" (click)="closeForm()">Cancel</button>
        <button nz-button nzType="primary" (click)="saveRow()">{{ editData && editData.length > 0 ? 'Update':'Save'
            }}</button>
    </div>
    @if(editData && editData.length == 0){
    <div class="row d-flex align-items-center" style="padding: 0px 30px 0px 30px;">
        <div class="col-md-10 d-flex mb-1 flex-column position-relative custom-select-v2">
            <label class="form-label"> Search AR #
            </label>
            @if(editData.length == 0){
            <nz-select [nzDisabled]="editData && editData.length > 0" (nzOpenChange)="onOpenSelect($event)"
                #multiSelectRef nzMode="multiple" [(ngModel)]="selectedUsers" (ngModelChange)="userChange($event)"
                (nzOnSearch)="userValChange($event)" nzPlaceHolder="Select AR #" nzSize="default"
                style="height: 35px !important;" [nzDropdownRender]="dropDownRender">
                @for(user of userList;track user?.arNo){
                <nz-option [nzLabel]="user?.arNo+'-'+user?.customerName" [nzValue]="user"
                    [nzDisabled]="user?.disabled"></nz-option>
                }
            </nz-select>
            <ng-template #dropDownRender>
                <div class="d-flex justify-content-end p-2">
                    <button nz-button nzType="primary" class="ok-btn" (click)="closeSelect(multiSelectRef)">
                        Ok
                    </button>
                </div>
            </ng-template>
            }
            @else {
            <input type="text" disabled [value]="editData[0].siteCustomerId + '-' +editData[0].customerDesc"
                class="form-control">
            }

            <span class="error-text mt-5" *ngIf="(invalidForm || invalidUserList) && selectedUsers.length == 0">
                Atleast one AR # is required for association.
            </span>
        </div>
        <div class="col-md-2 d-flex mt-4">
            <button nz-button nzType="primary" [disabled]="editData && editData.length > 0"
                (click)="addRow()">Associate</button>
        </div>
    </div>
    }
    <div class="form-container position-relative mt-2">
        <form [formGroup]="addEditUserForm">
            <div class="row">
                @for(panel of associateUserFields; track panel.id){
                <ng-container formArrayName="userArray">

                    @for(list of associateUserArray;let j = $index; track list){
                    <nz-collapse cdkDrag class="mb-3" style="background-color: #ffff;" nzAccordion>

                        <nz-collapse-panel [nzDisabled]="true" #panelRef [nzActive]="true" [nzShowArrow]="false">
                            <div [formGroup]="list" class="row d-flex align-self-center align-items-center mb-0">
                                <div class="d-flex justify-content-end ">
                                    <button nz-button nzType="default" (click)="clearRow(j)">Reset</button>
                                </div>
                                <div class="d-flex">
                                    @for(field of panel.fields;track field){
                                    @if(field.fieldType == 'input'){
                                    <ng-container>
                                        @if(field.fieldName == 'AR No'){
                                        <div class="w-17 mb-1 px-2">
                                            <label class="form-label"> {{field.fieldName}}
                                                @if(field.required){
                                                <span class="text-danger">*</span>
                                                }</label>
                                            <input type="text" class="form-control" placeholder={{field?.placeholder}}
                                                formControlName="{{field?.formControlName}}">
                                            <span class="text-danger"
                                                *ngIf="field.required && !userArray.get(field?.formControlName)?.value &&  (userArray.get(field?.formControlName)?.touched) && (userArray.get(field?.formControlName)?.dirty)">
                                                {{field?.fieldName}} is required.
                                            </span>
                                        </div>
                                        }
                                        @else {
                                        <div class="w-75 mb-1 position-relative px-2">
                                            <label class="form-label"> {{field.fieldName}}
                                                @if(field.required){
                                                <span class="text-danger">*</span>
                                                }</label>
                                            <input type="text" class="form-control" placeholder={{field?.placeholder}}
                                                formControlName="{{field?.formControlName}}">
                                            <span class="error-text"
                                                *ngIf="invalidUserForm && associateUserArray[j].get(field?.formControlName)?.hasError('required')">
                                                {{field?.fieldName}} is required.
                                            </span>
                                        </div>
                                        }
                                    </ng-container>
                                    }
                                    @else if(field.fieldType == 'dropdown'){
                                    <div class="w-50 d-flex flex-column mb-1 position-relative px-2">
                                        <label class="form-label"> {{field.fieldName}}
                                            @if(associateUserArray[j].get(field?.formControlName)?.hasError('required')){
                                            <span class="text-danger">*</span>
                                            }</label>
                                        <nz-select nzPlaceHolder="Select" nzSize="default" [nzShowSearch]="true"
                                            [nzAutoClearSearchValue]="true" formControlName="{{field?.formControlName}}"
                                            style="height: 38px !important;">
                                            @if(field.formControlName == 'loginPageID'){
                                                 <nz-option [nzLabel]="'Select'" [nzValue]=""></nz-option>
                                            @for(user of customerDropDownLists.loginPage; track user.value){                                      
                                            <nz-option [nzLabel]="user.description" [nzValue]="user.value"></nz-option>
                                            }
                                            }
                                            @else if(field.formControlName == 'styleSheet'){
                                            <nz-option [nzLabel]="'Select'" [nzValue]=""></nz-option>
                                            @for(style of customerDropDownLists.theme; track style.value){
                                            <nz-option [nzLabel]="style.description"
                                                [nzValue]="style.value"></nz-option>
                                            }
                                            }
                                            @else if(field.formControlName == 'brand'){
                                            <nz-option [nzLabel]="'Select'" [nzValue]=""></nz-option>
                                            @for(brand of customerDropDownLists.brand; track brand.value){
                                            <nz-option [nzLabel]="brand.description"
                                                [nzValue]="brand.value"></nz-option>
                                            }
                                            }
                                        </nz-select>
                                        <span class="error-text"
                                            *ngIf="invalidUserForm && associateUserArray[j].get(field?.formControlName)?.hasError('required')  && !associateUserArray[j].get(field?.formControlName)?.value">
                                            {{field?.fieldName}} is required.
                                        </span>
                                    </div>
                                    }
                                    }
                                </div>
                            </div>

                        </nz-collapse-panel>

                    </nz-collapse>
                    }
                </ng-container>
                }
            </div>
        </form>
    </div>
</section>